import { FeaturedWorkKey } from "module/types";

export type FeaturedWorkLocalizationType = Record<
  FeaturedWorkKey,
  FeaturedWorkLocalizationAttributesType
>;

type FeaturedWorkLocalizationAttributesType = {
  title: string;
  subtitle: string;
  description: string;
};

export const featuredWorkLocalizations_en: FeaturedWorkLocalizationType = {
  [FeaturedWorkKey.werewolf_online]: {
    title: "Werewolf Online",
    subtitle: "Multiplayer Game Inspired by Lupus in Tabula",
    description:
      "A 3D multiplayer game based on inspiration from Lupus in Tabula. Applied unique roles and rules.",
  },
  [FeaturedWorkKey.minigames]: {
    title: "Mini Game Party",
    subtitle: "Local Multiplayer Games Using Mobile and PC",
    description:
      "A collection of local multiplayer games where the mobile device acts as the controller and the PC serves as the game console. Carried out a government-supported project using this game model.",
  },
  [FeaturedWorkKey.avatar_customizing]: {
    title: "Avatar Customizing",
    subtitle: "3D avatar customizing module",
    description:
      "A module that allows the movement, rotation, and adjustment of individual body parts & joints of a 3D avatar.",
  },
  [FeaturedWorkKey.pocket_ball]: {
    title: "Pocket Ball",
    subtitle: "Local multiplayer pocket ball game",
    description:
      "A local multiplayer Pocket Ball game played with mobile controller and PC console, following the same concept as MiniGames.",
  },
  [FeaturedWorkKey.holdem]: {
    title: "Holdem",
    subtitle: "Local multiplayer card game",
    description:
      "A local multiplayer Holdem game played with mobile controller and PC console, following the same concept as MiniGames.",
  },
  [FeaturedWorkKey.sharp_shooter]: {
    title: "",
    subtitle: "",
    description: "",
  },
  [FeaturedWorkKey.cms]: {
    title: "Smart Media Board CMS",
    subtitle: "Android set-top box application",
    description:
      "Maintained Android application for set-top boxes and server systems of media board CMS solution.",
  },
  [FeaturedWorkKey.face]: {
    title: "Face Detection",
    subtitle:
      "Children Care Application Implementing Face Detection Using OpenCV",
    description:
      "Using OpenCV in Android Native environment to enable face detection via the camera. Upon detection, the image is automatically captured and then processed with Amazon Rekognition to distinguish the face using a pre-trained model.",
  },
  [FeaturedWorkKey.soundable]: {
    title: "Soundable Health",
    subtitle: "Digital health application service",
    description: "",
  },
  [FeaturedWorkKey.others]: {
    title: "Others",
    subtitle: "",
    description: "",
  },
};

export const featuredWorkLocalizations_ko: FeaturedWorkLocalizationType = {
  [FeaturedWorkKey.werewolf_online]: {
    title: "늑대인간 온라인",
    subtitle: "타뷸라의 늑대 기반 3D 멀티플레이 마피아 장르 게임",
    description:
      "타뷸라의 늑대를 모티브로 만든 3D 멀티플레이 마피아 장르의 게임으로, 다양한 역할군과 진행방식을 적용.",
  },
  [FeaturedWorkKey.minigames]: {
    title: "미니게임 파티",
    subtitle: "모바일을 컨트롤러로 하는 다양한 로컬 멀티플레이 게임",
    description:
      "모바일을 컨트롤러, PC를 게임화면으로 사용하는 로컬 멀티플레이 게임의 모음. 정부지원사업에 선정되어 진행한 이력이 있음.",
  },
  [FeaturedWorkKey.avatar_customizing]: {
    title: "아바타 커스터마이징",
    subtitle: "3D 아바타 커스터마이징 모듈",
    description:
      "3D 아바타의 각 부위와 관절을 이동, 회전, 조절할 수 있는 모듈.",
  },
  [FeaturedWorkKey.pocket_ball]: {
    title: "포켓볼",
    subtitle: "로컬 멀티플레이 포켓볼 게임",
    description:
      "모바일 컨트롤러와 PC를 콘솔로 플레이하는 로컬 멀티플레이 포켓볼 게임. 미니게임 파티와 동일한 컨셉.",
  },
  [FeaturedWorkKey.holdem]: {
    title: "홀덤",
    subtitle: "로컬 멀티플레이 카드 게임",
    description:
      "모바일 컨트롤러와 PC를 콘솔로 플레이하는 로컬 멀티플레이 홀덤 게임. 미니게임 파티와 동일한 컨셉.",
  },
  [FeaturedWorkKey.sharp_shooter]: {
    title: "",
    subtitle: "",
    description: "",
  },
  [FeaturedWorkKey.cms]: {
    title: "스마트 미디어 보드 CMS",
    subtitle: "안드로이드 셋톱박스 애플리케이션",
    description:
      "미디어 보드 CMS 솔루션의 안드로이드 셋톱박스 앱과 서버 시스템 유지보수.",
  },
  [FeaturedWorkKey.face]: {
    title: "얼굴 인식 앱",
    subtitle: "OpenCV 기반 얼굴 인식 앱",
    description:
      "Android에서 OpenCV를 통해 카메라 얼굴 인식 구현. 인식 시 자동 촬영 후 Amazon Rekognition을 통해 얼굴 식별.",
  },
  [FeaturedWorkKey.soundable]: {
    title: "사운더블 헬스",
    subtitle: "디지털 헬스케어 서비스",
    description: "",
  },
  [FeaturedWorkKey.others]: {
    title: "기타",
    subtitle: "",
    description: "",
  },
};
